import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../PlantDesignDetails.module.scss';
import { FormGroup, Input } from '@snsw/react-component-library';
import { isEmpty, isNumeric, validateExt } from 'shared/utils/Validation';
import { PlantDesignDetailsPage } from 'plantDesign/constants/plantDesignDetailsPage';

export const EscalatorDesignDetails = React.forwardRef((props, ref) => {
  const {
    maxSpeed: savedMaxSpeed = '',
    maxAngle: savedMaxAngle = '',
    maxTravel: savedMaxTravel = '',
    maxWidth: savedMaxWidth = '',
    maxPassengers: savedMaxPassengers = '',
  } = props.value || {};

  const [maxSpeed, setMaxSpeed] = useState(savedMaxSpeed);

  const [maxAngle, setMaxAngle] = useState(savedMaxAngle);
  const [maxTravel, setMaxTrave] = useState(savedMaxTravel);
  const [maxWidth, setMaxWidth] = useState(savedMaxWidth);
  const [maxPassengers, setMaxPassengers] = useState(savedMaxPassengers);
  const [showErrors, setShowErrors] = useState(false);

  const [errors, setErrors] = useState({});
  const [errorSummary, setErrorSummary] = useState([]);

  const PAGE_CONSTANTS = PlantDesignDetailsPage.escalator;

  const validators = [
    {
      fieldName: 'maxSpeed',
      fieldValue: maxSpeed,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxAngle',
      fieldValue: maxAngle,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxTravel',
      fieldValue: maxTravel,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxWidth',
      fieldValue: maxWidth,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxPassengers',
      fieldValue: maxPassengers,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
  ];

  if (ref) {
    ref.current = {
      validate: () => {
        let isCurrentComponentValid = validateExt(validators, setErrors, setErrorSummary);

        setShowErrors(!isCurrentComponentValid);

        return isCurrentComponentValid;
      },
    };
  }

  useEffect(() => {
    let details = {
      maxSpeed,
      maxAngle,
      maxTravel,
      maxWidth,
      maxPassengers,
    };

    if (props.onChange) props.onChange(details);

    if (showErrors) validateExt(validators, setErrors, setErrorSummary);
  }, [maxSpeed, maxAngle, maxTravel, maxWidth, maxPassengers]);

  useEffect(() => {
    if (props.onErrorChange) props.onErrorChange(errorSummary);
  }, [errorSummary]);

  return (
    <>
      <FormGroup
        id="maxSpeed"
        label={PAGE_CONSTANTS.maxSpeed.label}
        isRequired
        errorMessage={errors?.maxSpeed?.errorMessage}
        hasError={showErrors && errors?.maxSpeed?.invalid}
        className={styles.inputWithSuffix}
        margin={{ top: 'md' }}
      >
        <Input
          suffix={PAGE_CONSTANTS.maxSpeed.suffix}
          onChange={(e) => {
            setMaxSpeed(e.target.value);
          }}
          value={maxSpeed}
        />
      </FormGroup>

      <FormGroup
        id="maxAngle"
        label={PAGE_CONSTANTS.maxAngle.label}
        isRequired
        errorMessage={errors?.maxAngle?.errorMessage}
        hasError={showErrors && errors?.maxAngle?.invalid}
        className={styles.inputWithSuffix}
        margin={{ top: 'md' }}
      >
        <Input
          suffix={PAGE_CONSTANTS.maxAngle.suffix}
          onChange={(e) => {
            setMaxAngle(e.target.value);
          }}
          value={maxAngle}
        />
      </FormGroup>
      <FormGroup
        id="maxTravel"
        label={PAGE_CONSTANTS.maxTravel.label}
        isRequired
        errorMessage={errors?.maxTravel?.errorMessage}
        hasError={showErrors && errors?.maxTravel?.invalid}
        className={styles.inputWithSuffix}
        margin={{ top: 'md' }}
      >
        <Input
          suffix={PAGE_CONSTANTS.maxTravel.suffix}
          onChange={(e) => {
            setMaxTrave(e.target.value);
          }}
          value={maxTravel}
        />
      </FormGroup>
      <FormGroup
        id="maxWidth"
        label={PAGE_CONSTANTS.maxWidth.label}
        isRequired
        errorMessage={errors?.maxWidth?.errorMessage}
        hasError={showErrors && errors?.maxWidth?.invalid}
        className={styles.inputWithSuffix}
        margin={{ top: 'md' }}
      >
        <Input
          suffix={PAGE_CONSTANTS.maxWidth.suffix}
          onChange={(e) => {
            setMaxWidth(e.target.value);
          }}
          value={maxWidth}
        />
      </FormGroup>

      <FormGroup
        id="maxPassengers"
        label={PAGE_CONSTANTS.maxPassengers.label}
        isRequired
        errorMessage={errors?.maxPassengers?.errorMessage}
        hasError={showErrors && errors?.maxPassengers?.invalid}
        margin={{ top: 'md' }}
      >
        <Input
          onChange={(e) => {
            setMaxPassengers(e.target.value);
          }}
          value={maxPassengers}
          inputWidth="xs"
        />
      </FormGroup>
    </>
  );
});

EscalatorDesignDetails.displayName = 'EscalatorDesignDetails';

EscalatorDesignDetails.propTypes = {
  value: PropTypes.object,
  refData: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onErrorChange: PropTypes.func.isRequired,
};
